/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Username`)
};

const zh_hans1_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新用户名`)
};

const zh_hant1_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新使用者名稱`)
};

const fr_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre à jour le nom d’utilisateur`)
};

const de_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzernamen aktualisieren`)
};

const ja_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名を更新`)
};

const ko_settings_update_username = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름 업데이트`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_update_username = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_update_username(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_update_username", locale)
	if (locale === "en") return en_settings_update_username(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_update_username(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_update_username(inputs)
	if (locale === "fr") return fr_settings_update_username(inputs)
	if (locale === "de") return de_settings_update_username(inputs)
	if (locale === "ja") return ja_settings_update_username(inputs)
	return ko_settings_update_username(inputs)
};